import React, {useRef, useState} from "react";
import Box from "@mui/material/Box";
import {Button, Divider, Grid, Stack} from "@mui/material";
import InputField from "../../components/InputField";
import AlertBar from "../../components/AlertBar";
import Form from "../../components/Form";
import {BASE_URL} from "../../constants";
import {formatDateTimeForDb, reportErrors} from "../../helpers";
import DateField from "../../components/DateField";

const genders = [
    {label: "Diesel", value: "Diesel"},
    {label: "Petrol", value: "Petrol"},
    {label: "Gas", value: "Gas"},
];
export default function AddTrip(props) {
    const form = useRef();
    const alert = useRef();
    const plateNumberRef = useRef();
    const startDateRef = useRef();
    const endDateRef = useRef();
    const commentRef = useRef();

    const [plateNumber, setPlateNumber] = useState(props.data?.plateNumber);
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [comments, setComments] = useState();
    const [canSubmit, setCanSubmit] = useState(true);
    const submit = () => {
        let data = {
            truckId: props.data?.truckId,
            startDate: formatDateTimeForDb(startDate),
            endDate: formatDateTimeForDb(endDate),
            remarks:comments
        }
        if (canSubmit && form.current.validate()) {
            setCanSubmit(false);
            alert.current.showProgress();
            window.axios
                .post(`${BASE_URL}api/booking`, data)
                .then(response => {
                    alert.current.showSuccess("Create Successfully.");
                    setCanSubmit(true);
                    setTimeout(() => {
                        props.modal.current.hide();
                        props.loadData();
                    }, 1000)
                })
                .catch(error => {
                    setCanSubmit(true);
                    reportErrors(alert.current, error);
                });
        }
    }
    return (
        <Box>
            <Form ref={form}>
                <AlertBar ref={alert}/>
                <Grid container spacing={2} sx={{p: 1}}>
                    <Grid item xs={12}>
                        <InputField
                            disabled={true}
                            required={true}
                            ref={plateNumberRef}
                            defaultValue={plateNumber}
                            type="text"
                            label="Plate Number"
                            onChange={(value) => setPlateNumber(value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DateField
                            ref={startDateRef}
                            showTimeSelect={true}
                            label="Start Date"
                            dateFormat={"yyyy-MM-dd HH:mm"}
                            clearable={true}
                            selected={startDate}
                            onChange={(value) => setStartDate(value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <DateField
                            ref={endDateRef}
                            showTimeSelect={true}
                            label="End Date"
                            dateFormat={"yyyy-MM-dd HH:mm"}
                            clearable={true}
                            selected={endDate}
                            onChange={(value) => setEndDate(value)}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputField
                            required={true}
                            ref={commentRef}
                            defaultValue={comments}
                            type="text"
                            label="Comments"
                            multiline={true}
                            onChange={(value) => setComments(value)}
                        />
                    </Grid>
                    <Grid item xs={12}><Divider/></Grid>
                    <Grid item xs={12}>
                        <Stack alignItems="center"
                               justifyContent="center">
                            <Grid item xs={2}>
                                <Button
                                    disabled={!canSubmit}
                                    sx={{my: 1, textTransform: "none"}}
                                    disableElevation
                                    size="medium"
                                    variant="contained"
                                    color="primary"
                                    onClick={() => submit()}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </Stack>
                    </Grid>
                </Grid>
            </Form>
        </Box>
    );
}